var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex lg:flex-row flex-col gap-4" },
    [
      _c(
        "v-col",
        { staticClass: "bg-white" },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-card-text",
                [
                  _c("title-label", {
                    attrs: {
                      label: _vm.$t("message.orderMessage.title"),
                      "prepend-icon": "mdi-email",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "mt-6" },
                    [
                      _c("toggle-form", {
                        attrs: {
                          text: _vm.$t(
                            "linkbill.useCustomerLink.orderLinkTextShowProduct"
                          ),
                          state: _vm.state["orderLinkTextShowProduct"],
                        },
                        on: {
                          input: function ($event) {
                            return _vm.submit("orderLinkTextShowProduct")
                          },
                        },
                        model: {
                          value: _vm.form.orderLinkTextShowProduct,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "orderLinkTextShowProduct", $$v)
                          },
                          expression: "form.orderLinkTextShowProduct",
                        },
                      }),
                      _c("toggle-form", {
                        attrs: {
                          "false-value": true,
                          "true-value": false,
                          text: _vm.$t("message.orderMessage.showSummaryOrder"),
                          state: _vm.state["hideOrderSummaryTextInSummaryText"],
                        },
                        on: {
                          input: function ($event) {
                            return _vm.submit(
                              "hideOrderSummaryTextInSummaryText"
                            )
                          },
                        },
                        model: {
                          value: _vm.form.hideOrderSummaryTextInSummaryText,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "hideOrderSummaryTextInSummaryText",
                              $$v
                            )
                          },
                          expression: "form.hideOrderSummaryTextInSummaryText",
                        },
                      }),
                      _c("toggle-form", {
                        attrs: {
                          text: _vm.$t("linkbill.useCustomerLink.title"),
                          state: _vm.state["useCustomerLink"],
                        },
                        on: {
                          input: function ($event) {
                            return _vm.submit("useCustomerLink")
                          },
                        },
                        model: {
                          value: _vm.form.useCustomerLink,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "useCustomerLink", $$v)
                          },
                          expression: "form.useCustomerLink",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("text-field-label", {
                    attrs: {
                      label: _vm.$t("message.orderMessage.summaryOrder"),
                    },
                  }),
                  _c("text-editor", {
                    attrs: {
                      state: _vm.state["orderSummaryText"],
                      disabled: _vm.form.hideOrderSummaryTextInSummaryText,
                    },
                    on: {
                      submit: function ($event) {
                        return _vm.submit("orderSummaryText")
                      },
                      input: function ($event) {
                        return _vm.preview("orderSummaryText")
                      },
                      focus: function ($event) {
                        return _vm.preview("orderSummaryText")
                      },
                    },
                    model: {
                      value: _vm.form.orderSummaryText,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "orderSummaryText", $$v)
                      },
                      expression: "form.orderSummaryText",
                    },
                  }),
                  _c("text-field-label", {
                    attrs: {
                      label: _vm.$t("message.orderMessage.summaryLink"),
                    },
                  }),
                  _c("text-editor", {
                    attrs: {
                      "default-value": _vm.defaultValue.orderLinkText,
                      state: _vm.state["orderLinkText"],
                    },
                    on: {
                      submit: function ($event) {
                        return _vm.submit("orderLinkText")
                      },
                      input: function ($event) {
                        return _vm.preview("orderLinkText")
                      },
                      focus: function ($event) {
                        return _vm.preview("orderLinkText")
                      },
                    },
                    model: {
                      value: _vm.form.orderLinkText,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "orderLinkText", $$v)
                      },
                      expression: "form.orderLinkText",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "w-full bg-white",
          style: { maxWidth: "100%" },
          attrs: { cols: "4" },
        },
        [
          _c(
            "v-card",
            { staticClass: "p-7 flex flex-col gap-7", attrs: { flat: "" } },
            [
              _c("title-label", {
                attrs: {
                  label: _vm.$t("message.orderMessage.previewSummaryOrder"),
                  "prepend-icon": "mdi-email",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "p-1 rounded-lg text-xs flex flex-col gap-3",
                  style: { boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.25)" },
                },
                [
                  _c("div", { staticClass: "flex items-center p-2 pb-0" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/example_message/left.png"),
                      },
                    }),
                    _c("div", { staticClass: "flex items-center gap-1 pl-4" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/example_message/logo.png"),
                        },
                      }),
                      _c("div", { staticClass: "flex flex-col" }, [
                        _c("span", { staticClass: "text-sm font-medium" }, [
                          _vm._v("Shipnity"),
                        ]),
                        _c("span", { staticClass: "text-disabled" }, [
                          _vm._v("Messenger"),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "flex gap-3 items-center justify-end" },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/example_message/call.png"),
                          },
                        }),
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/example_message/video_call.png"),
                          },
                        }),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "px-7 py-3",
                      style: {
                        borderRadius: "32px 32px 32px 4px",
                        backgroundColor: "#E9E9F2",
                      },
                    },
                    [
                      _c("div", { staticClass: "mt-3" }, [
                        _vm._v(" เลขที่ใบสั่งซื้อ: AB123 "),
                        _vm.form.orderLinkTextShowProduct
                          ? _c("div", [
                              _vm._v(" รายการสินค้า "),
                              _c("br"),
                              _vm._v(" กางเกง ราคา 100.00 บาท "),
                              _c("br"),
                              _c("br"),
                              _vm._v(" รหัสส่วนลด ABCDE มูลค่า 20.00 บาท "),
                              _c("br"),
                              _vm._v(" ค่าส่ง EMS 0.00 บาท "),
                              _c("br"),
                              _vm._v(" ยอดรวม 80.00 บาท "),
                              _c("br"),
                              _c("br"),
                              !_vm.form.hideOrderSummaryTextInSummaryText
                                ? _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.form.orderSummaryText
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]),
                      _vm.form.useCustomerLink
                        ? _c("div", [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.form.orderLinkText),
                              },
                            }),
                            _vm._v(" https://track.shipnity.com/abcdefg "),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }